import { Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import DialogHeader from './DialogHeader'
import { useTranslation } from 'react-i18next'

const DialogConfirmChangeVersion = ({
    titleKey,
    onClose,
    contentKey,
    actionKey,
    onAction,
    versionName,
    version
}) => {

    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)

    const handleAction = () => {
        try {
            setIsLoading(true)
            onAction && onAction()
        } catch (error) {
            console.log('err', error)
        } finally {
            setIsLoading(false)
            onClose()
        }
    }

    return (
        <Dialog open onClose={onClose}>
            <DialogHeader onClose={onClose} titleKey={titleKey} />
            <DialogContent>
                <Stack>
                    <Typography mt={1}>{t(contentKey)}</Typography>
                    <Typography mt={1} sx={{ display: 'flex' }}>{t('version.contentVersionName')}: <span style={{ fontWeight: 600, display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginLeft: 4, maxWidth: 300 }}>{versionName}</span></Typography>
                    <Typography>{t('version.contentVersion')}: <span style={{ fontWeight: 600 }}>{version}</span></Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onClose}>{t('actions.close')}</Button>
                <Button disabled={isLoading} onClick={handleAction}>{t(actionKey)}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogConfirmChangeVersion